/**
 * Context when navigating from Birthday page to send gift/shared/campaign.
 * Cleared after the target page applies it.
 */
const getDefaultState = () => ({
  receiver: null,
  group: null,
  circleType: null, // 'individual' | 'regular' | 'business'
  forEvent: false,
  groupColorCode: null,
  selectedCard: null,  // gift card from birthday wishlist
  selectedGift: null,  // gift item from birthday wishlist (if any)
});

const state = getDefaultState();

const getters = {
  hasContext(state) {
    return !!state.receiver;
  },
  hasEventContext(state) {
    return !!state.receiver && state.forEvent;
  },
  receiver(state) {
    return state.receiver;
  },
  group(state) {
    return state.group;
  },
  circleType(state) {
    return state.circleType;
  },
  forEvent(state) {
    return state.forEvent;
  },
  groupColorCode(state) {
    return state.groupColorCode;
  },
  selectedCard(state) {
    return state.selectedCard;
  },
  selectedGift(state) {
    return state.selectedGift;
  },
};

const mutations = {
  SET_BIRTHDAY_SEND_CONTEXT(state, { receiver, group, circleType, forEvent, groupColorCode, selectedCard, selectedGift }) {
    state.receiver = receiver || null;
    state.group = group || null;
    state.circleType = circleType || 'individual';
    state.forEvent = !!forEvent;
    state.groupColorCode = groupColorCode || null;
    state.selectedCard = selectedCard || null;
    state.selectedGift = selectedGift || null;
  },
  CLEAR_BIRTHDAY_SEND_CONTEXT(state) {
    state.receiver = null;
    state.group = null;
    state.circleType = null;
    state.forEvent = false;
    state.groupColorCode = null;
    state.selectedCard = null;
    state.selectedGift = null;
  },
};

const actions = {
  setBirthdaySendContext({ commit }, payload) {
    commit('SET_BIRTHDAY_SEND_CONTEXT', payload);
  },
  clearBirthdaySendContext({ commit }) {
    commit('CLEAR_BIRTHDAY_SEND_CONTEXT');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
